import {
  Box,
  SimpleGrid,
  Skeleton,
  SkeletonCircle,
  SkeletonText,
  Stack,
} from "@chakra-ui/react"

export type PageSkeletonVariant = "detail" | "stats" | "table"

export interface PageSkeletonProps {
  variant?: PageSkeletonVariant
  rows?: number
}

export function PageSkeleton({
  variant = "detail",
  rows = 4,
}: PageSkeletonProps) {
  if (variant === "stats") {
    return (
      <SimpleGrid columns={{ base: 1, md: 2, lg: 4 }} gap={4} w="full">
        {Array.from({ length: 4 }).map((_, index) => (
          <Box key={index} borderWidth="1px" borderRadius="lg" p={4}>
            <Skeleton height="16px" width="40%" mb={2} />
            <Skeleton height="32px" width="60%" />
          </Box>
        ))}
      </SimpleGrid>
    )
  }

  if (variant === "table") {
    return (
      <Stack gap={3} w="full">
        <Skeleton height="36px" width="30%" />
        <Box borderWidth="1px" borderRadius="lg" overflow="hidden">
          <Skeleton height="44px" />
          {Array.from({ length: rows }).map((_, index) => (
            <Skeleton key={index} height="56px" />
          ))}
        </Box>
      </Stack>
    )
  }

  return (
    <Stack gap={4} w="full">
      <Skeleton height="32px" width="50%" />
      <SkeletonText noOfLines={rows} />
      <Stack direction="row" gap={4} align="center">
        <SkeletonCircle size="10" />
        <SkeletonText noOfLines={2} width="60%" />
      </Stack>
    </Stack>
  )
}
